(function () {

    'use strict';

    angular.module('app').controller('AccountingCustomerBillingDetailsController', AccountingCustomerBillingDetailsController);

    AccountingCustomerBillingDetailsController.$inject = [
        'AccountingService',
        '$routeParams',
        'toastr',
        '$location',
        'AccountingCustomerBillingShipmentsTableService',
        'ConfirmationModalFactory',
        '$window',
        '$uibModal',
        '$q'
    ];

    function AccountingCustomerBillingDetailsController(
        AccountingService,
        $routeParams,
        toastr,
        $location,
        AccountingCustomerBillingShipmentsTableService,
        ConfirmationModalFactory, 
        $window,
        $uibModal,
        $q
    ){
        const vm = this;
        vm.downloadFile = downloadFile;
        vm.runBillingAndEmailToCustomer = runBillingAndEmailToCustomer;
        vm.runAndCloseCustomerBilling = runAndCloseCustomerBilling;
        vm.back = back;

        // todo: remove this one here
        const billingEmailAlreadySent = new ConfirmationModalFactory({}, {
            message: 'messages.warning.billingEmailAlreadySent.MESSAGE', 
            code: 'messages.warning.billingEmailAlreadySent.CODE'
        });

        // todo: remove this one here
        const sendBillingEmail = new ConfirmationModalFactory({}, {
            message: 'messages.warning.sendEmailToCustomer.MESSAGE', 
            code: 'messages.warning.sendEmailToCustomer.CODE'
        });

        const closeBillingConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.closeBilling.MESSAGE',
            code: 'messages.warning.closeBilling.CODE'
        });
        
        init();

        function init(){
            vm.isFetching = true;
            AccountingService.CustomerBilling.getOne(data => {
                vm.isFetching = false;
                vm.customer = data.customer;
                vm.data = data;
                vm.shipmentsTable = new AccountingCustomerBillingShipmentsTableService().tableData;
            }, () => {
                toastr.error('Unable to fetch Customer Information');
                $location.path('/accounting/customer-billing');
            }, $routeParams.id);
        }

        function downloadFile(type) {
            const payload = {
                customerId: $routeParams.id,
                fileType: type
            };
            AccountingService.CustomerBilling.downloadFile(function(result) {
            }, function(error) {
                toastr.error(error.message || 'Try again', 'Unable to download file');
            }, payload);
        };

        function runBillingAndEmailToCustomer() {
            const modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                windowClass: 'setting-modal',
                templateUrl: '/templates/pages/accounting/modals/email-billing-modal.html',
                controller: 'EmailBillingModalController',
                controllerAs: 'vm',
                size: 'md',
                appendTo: $('body')
            });

            modalInstance.result.then((fileType) => {
                if (!fileType) { return; } 
                processCloseBilling(vm.data.id, fileType.value, true).then(data => {
                    $location.path('/accounting-billing');
                    toastr.success('Billing has been sent to the customer', 'Success');
                }, error => {
                    toastr.error(error.error.message, 'Error');
                });
            });
        }

        function runAndCloseCustomerBilling() {
            vm.closingBill = true;
            closeBillingConfirmation.getInstance().result.then(cond => {
                if (cond) {
                    processCloseBilling(vm.data.id, null, false).then(data => {
                        vm.closingBill = false;
                        toastr.success('Billing has been closed', 'Success');
                        $location.path('/accounting-billing');
                    }, error => {
                        vm.closingBill = false;
                        toastr.error(error.error.message, 'Error');
                    });
                    return;
                }
                
                vm.closingBill = false;
            });
        }

        function processCloseBilling(id, fileTypes = null, sendEmail) {
            const defer = $q.defer();
            AccountingService.CustomerBilling.closeBilling(success => {
                defer.resolve(success);
            }, error => {
                defer.reject(error);
            }, id, fileTypes, sendEmail);

            return defer.promise;
        }

        function back(){
            $window.history.back();
        }
    }

})();



// WEBPACK FOOTER //
// ./js/controllers/accounting/AccountingCustomerBillingDetailsController.js